import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';

export function getFormularioListSuccess(formulario) {
  return {type: types.LOAD_FORMULARIO_LIST_SUCCESS, formulario};
}



export function getFormularioList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().FormularioApi.getFormularioList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(formulario => {   
                  dispatch(getFormularioListSuccess(formulario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getFormularioSuccess(catalogo) {
  return {type: types.LOAD_FORMULARIO_SUCCESS, catalogo};
}

export function getFormulario(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().FormularioApi.getFormulario(id, token).then(formulario => {   
        dispatch(getFormularioSuccess(formulario));
        return formulario;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function getExamen(id, idCurso, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().FormularioApi.getExamen(id, idCurso, token).then(formulario => {   
        dispatch(getFormularioSuccess(formulario));
        return formulario;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(formulario) {
  return {type: types.SAVE_FORMULARIO_SUCCESS, formulario};
}


export function save(formulario, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().FormularioApi.save(formulario, token).then(formularioGuardado => {
    dispatch(saveSuccess(formularioGuardado));
    return formularioGuardado;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getFormularioComboSuccess(datos) {
  return {type: types.GET_FORMULARIOS_COMBO_SUCCESS, datos};
}

export function getFormularioCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().FormularioApi.getFormularioCombo(token).then(datos => {   
        
      dispatch(getFormularioComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(formulario) {
  return {type: types.BORRAR_FORMULARIO_SUCCESS, formulario};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().FormularioApi.borrar(id, token ).then(formulario => {
               
                  dispatch(borrarSuccess(formulario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setDuplicar(examen, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().FormularioApi.setDuplicar(examen, token).then(examenGuardado => {   
    dispatch(saveSuccess(examenGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function activarSuccess(formulario) {
  return {type: types.ACTIVAR_FORMULARIO_SUCCESS, formulario};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().FormularioApi.activar(id, token).then(formulario => {
               
                  dispatch(activarSuccess(formulario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_FORMULARIO, filtro};
}



